import { render, staticRenderFns } from "./order-subcategorias.vue?vue&type=template&id=4c2e83c1&scoped=true"
import script from "./order-subcategorias.vue?vue&type=script&lang=js"
export * from "./order-subcategorias.vue?vue&type=script&lang=js"
import style0 from "./order-subcategorias.vue?vue&type=style&index=0&id=4c2e83c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e83c1",
  null
  
)

export default component.exports